import {
    Material,
    MeshBasicMaterial,
    MeshPhongMaterial,
    MeshPhysicalMaterial,
} from 'three';
import { EditableFields, EditableObject } from './fields';

export namespace MaterialFields {

    export const MeshPhong: ReadonlyArray<EditableFields<MeshPhongMaterial>> = [
        'color',
        'specular',
        'emissive',
        'emissiveIntensity',
        'shininess',
        'reflectivity',
        'transparent',
        'opacity',
    ];

    export const MeshPhysical: ReadonlyArray<EditableFields<MeshPhysicalMaterial>> = [
        'transparent',
        'opacity',
        'color',
        'emissive',
        'emissiveIntensity',
        'envMapIntensity',
        'metalness',
        'roughness',
        'reflectivity',
        'specularColor',
        'specularIntensity',
        'clearcoat',
        'clearcoatRoughness',
        'transmission',
        'thickness',
        'iridescence',
        'ior',
        'iridescenceIOR',
        'sheen',
        'sheenRoughness',
        'sheenColor',
        'attenuationColor',
        'attenuationDistance',
    ];

    export const MeshBasic: ReadonlyArray<EditableFields<MeshBasicMaterial>> = [
        'color',
        'opacity',
        'transparent',
    ];

    export type MeshPhongRepresentation = EditableFields.Representation<MeshPhongMaterial, typeof MeshPhong[number]>;
    export type MeshPhysicalRepresentation = EditableFields.Representation<MeshPhysicalMaterial, typeof MeshPhysical[number]>;
    export type MeshBasicRepresentation = EditableFields.Representation<MeshBasicMaterial, typeof MeshBasic[number]>;

    export type Representation = MeshPhongRepresentation | MeshPhysicalRepresentation | MeshBasicRepresentation;

    type MeshPhongSimplifiedRepresentation = EditableFields.SimplifiedRepresentation<MeshPhongMaterial, typeof MeshPhong[number]>;
    type MeshPhysicalSimplifiedRepresentation = EditableFields.SimplifiedRepresentation<MeshPhysicalMaterial, typeof MeshPhysical[number]>;
    type MeshBasicSimplifiedRepresentation = EditableFields.SimplifiedRepresentation<MeshBasicMaterial, typeof MeshBasic[number]>;

    export type SimplifiedRepresentation = MeshPhongSimplifiedRepresentation | MeshPhysicalSimplifiedRepresentation | MeshBasicSimplifiedRepresentation;

    export namespace Abstract {
        export type MeshPhong = EditableObject<MeshPhongMaterial, typeof MeshPhong>;
        export type MeshPhysical = EditableObject<MeshPhysicalMaterial, typeof MeshPhysical>;
        export type MeshBasic = EditableObject<MeshBasicMaterial, typeof MeshBasic>;
    }


    export function getAllowedFields<T extends Material = Material>(obj: T) {
        if (!(obj instanceof Material) || !obj.isMaterial) {
            return null;
        }

        if (obj instanceof MeshPhongMaterial) {
            return MeshPhong as ReadonlyArray<EditableFields<T>>;
        }

        if (obj instanceof MeshPhysicalMaterial) {
            return MeshPhysical as ReadonlyArray<EditableFields<T>>;
        }

        if (obj instanceof MeshBasicMaterial) {
            return MeshBasic as ReadonlyArray<EditableFields<T>>;
        }

        return null;
    }
}
